@if (profileField$ | async; as profileField) {
    <dt [id]="profileField.FieldDefinition.FlatKey" class="sh-description-list__term">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="$labelIcons()"></sh-field-label>
    </dt>
    @if (childDefinition$ | async; as childDefinition) {
        @if (listValues) {
            @if (listValues.length > 0) {
                <dd class="sh-description-list__details">
                    @for (value of listValues; track value; let index = $index) {
                        <span>
                            <med-complex-value-tag
                                [complexValue]="value"
                                [complexFieldDefinition]="childDefinition"
                                [label]="getWebserviceValue($any(value))"
                            ></med-complex-value-tag>
                            @if (index < listValues.length - 1) {
                                ,
                            }
                        </span>
                    }
                </dd>
            } @else {
                <dd class="sh-description-list__details">-</dd>
            }
        }
    }
}
